import { ManageApis } from '../../APIS/ManageApis';
import { getLocalStorage } from '../../Utils/Utils';

/**
 * Fetch country codes from API
 * @returns {Promise<Array>} Array of country codes with value and label
 */
export const fetchCountryCodesFromAPI = async () => {
  const token = getLocalStorage('token');
  try {
    const responseData = await ManageApis(
      'post',
      window.getCountryCodes,
      '',
      token
    );

    if (responseData?.data && Array.isArray(responseData.data)) {
      return responseData.data.map((country) => ({
        value: country.value || country.code || country.dial_code,
        label:
          country.label ||
          `${country.country_code || country.iso_code} ${
            country.value || country.code || country.dial_code
          }`,
      }));
    } else if (responseData?.response_data?.data) {
      return responseData.response_data.data.map((country) => ({
        value: country.value || country.code || country.dial_code,
        label:
          country.label ||
          `${country.country_code || country.iso_code} ${
            country.value || country.code || country.dial_code
          }`,
      }));
    } else {
      console.log('No country codes found in API response');
      return null;
    }
  } catch (error) {
    console.error('Error fetching country codes:', error);
    return null;
  }
};
